module.exports = __webpack_public_path__ + "static/media/1.4_manual.dc3d9805.png";